import TagFilters from 'Components/Table/TableComponents/TagFilters'
import { useAppSelector } from 'hooks'

function TagContainer(props) {
  const tableColumns = useAppSelector(state => state.present.tableOptions.tableColumns)
  const emptyTableColumns = useAppSelector(state => state.present.tableOptions.emptyTableColumns)
  const emptyExtraDescriptions = useAppSelector(state => state.present.tableOptions.emptyExtraDescriptions)
  const negateTableColumns = useAppSelector(state => state.present.tableOptions.negateTableColumns)
  const tableFilters = useAppSelector(state => state.present.tableOptions.tableFilters)
  const priceFilter = useAppSelector(state => state.present.tableOptions.priceFilter)

  const defaultCols = useAppSelector(state => state.present.tableOptions.defaultColumns)
  const allMarketplace = useAppSelector(state => state.present.configuration.allMarketplace)

  return (
    <TagFilters
      tableColumns={tableColumns}
      emptyTableColumns={emptyTableColumns}
      emptyExtraDescriptions={emptyExtraDescriptions}
      negateTableColumns={negateTableColumns}
      tableFilters={tableFilters}
      priceFilter={priceFilter}
      defaultCols={defaultCols}
      allMarketplace={allMarketplace}
      isFromDiWa={true}
    />
  )
}

export default TagContainer
